import { PaginationRequest, SearchRequest } from './common.request';

export enum ProviderSortColumnEnum {
  LAST_NAME = 'lastName',
  FIRST_NAME = 'firstName',
  NPI = 'npi',
  TIN = 'tin',
  STATUS = 'status'
}

export enum OrderByEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type GetAllProviderRequest = PaginationRequest & SearchRequest;
